import { useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';
// @ts-expect-error - no type definitions available
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { stampEditorFeature } from 'ContentEditorUI/utils/featureTracingUtils';
// @ts-expect-error - no type definitions available
import { getContent } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
// @ts-expect-error - no type definitions available
import { getIsPublished } from 'ContentEditorUI/redux/selectors/publishSelectors';
// @ts-expect-error - no type definitions available
import { getIsUngatedForArtifactFeatureTracing } from 'ContentEditorUI/redux/selectors/authSelectors';
const ArtifactFeatureTracer = () => {
  const content = useSelector(getContent);
  const isPublished = useSelector(getIsPublished);
  const isUngatedForArtifactFeatureTracing = useSelector(getIsUngatedForArtifactFeatureTracing);
  const store = useStore();
  useEffect(() => {
    const hasValidContent = !!(content && content.id);
    const isScalableEditor = EditorConfigSingleton.getIsOnScalableEditor();
    const tracingConfig = EditorConfigSingleton.get('artifactFeatureTracing');
    const hasTracingConfig = !!tracingConfig;
    const shouldSkipTracing = !isUngatedForArtifactFeatureTracing || !hasValidContent || !isScalableEditor || !hasTracingConfig;
    if (shouldSkipTracing) {
      return;
    }
    const {
      getEditorName,
      getArtifactType
    } = tracingConfig;
    const hasValidConfigFunctions = typeof getEditorName === 'function' && typeof getArtifactType === 'function';
    if (!hasValidConfigFunctions) {
      console.error('artifactFeatureTracing config must have getEditorName and getArtifactType functions');
      return;
    }
    const state = store.getState();
    const editorName = getEditorName(state);
    const artifactType = getArtifactType(state);
    const hasValidTracingData = editorName && typeof editorName === 'string' && artifactType && typeof artifactType === 'string';
    if (!hasValidTracingData) {
      console.error('artifactFeatureTracing selectors must return non-empty strings');
      return;
    }
    void stampEditorFeature({
      contentId: content.id,
      editorName,
      artifactType: artifactType,
      isPublished
    });
  }, [content, isPublished, isUngatedForArtifactFeatureTracing, store]);
  return null;
};
export default ArtifactFeatureTracer;